export default __webpack_public_path__ + "static/media/logoutOutlined.b7ca2242.svg";